import { STORE_SOCKET_INSTANCE_ACTION } from '../actions/socket'

export default function (state = null, action) {
    switch (action.type) {
        case STORE_SOCKET_INSTANCE_ACTION:
            return action.socket
        default:
            return state
    }
}
